import React from 'react';
import { useIntl } from 'react-intl';
import StepContainer from './components/StepContainer';
import PrerequisitesCard from './components/PrerequisitesCard';
import ClientConfiguration from './components/ClientConfiguration';
import VerifyConnectionSection from './components/VerifyConnectionSection';
import { MCP_SERVER_URL } from './constants';
import {
  Wrapper,
  StepContentGrid
} from './styled';

const MCP = () => {
  const intl = useIntl();

  return (
    <Wrapper>
      <StepContainer title={ intl.formatMessage({ id: 'mcp.step.prerequisites' }) } stepNumber={ 1 }>
        <StepContentGrid>
          <PrerequisitesCard
            title={ intl.formatMessage({ id: 'mcp.prerequisites.serverUrl.title' }) }
            description={ MCP_SERVER_URL }
          />
          <PrerequisitesCard
            title={ intl.formatMessage({ id: 'mcp.prerequisites.instanceUrl.title' }) }
            description={ intl.formatMessage({ id: 'mcp.prerequisites.instanceUrl.description' }) }
          />
          <PrerequisitesCard
            title={ intl.formatMessage({ id: 'mcp.prerequisites.credentials.title' }) }
            description={ intl.formatMessage({ id: 'mcp.prerequisites.credentials.description' }) }
          />
        </StepContentGrid>
      </StepContainer>
      <StepContainer title={ intl.formatMessage({ id: 'mcp.step.configure' }) } stepNumber={ 2 }>
        <ClientConfiguration mcpServerUrl={ MCP_SERVER_URL } />
      </StepContainer>
      <StepContainer title={ intl.formatMessage({ id: 'mcp.step.verify' }) } stepNumber={ 3 }>
        <VerifyConnectionSection />
      </StepContainer>
    </Wrapper>
  );
};

export default MCP;
